export default __webpack_public_path__ + "b03b7f1fb5658f52c6d68d54373e0430.png";